import { useMemo } from "react";

import { useGetCustomerPoints } from "@/generated/open-api/customer/customer";
import { convertObjToCamelCase } from "@/utils/converters";

export const useParsedGetCustomerPoints = (page: number) => {
  const { data, ...rest } = useGetCustomerPoints({ page });

  const customerPoints = useMemo(() => {
    if (!data?.data || !data?.meta) return;
    return {
      // 複数テーブルをマージした状態のpointが取得され、この状態でidは一意になっていない。
      // 一意なidを表現するため、どのテーブル情報かを表すtypeを識別子に加える。
      points: data.data.map((point) => ({
        key: `${point.type}-${point.id}`,
        ...convertObjToCamelCase(point),
      })),
      meta: convertObjToCamelCase(data.meta),
    };
  }, [data]);

  return { data: customerPoints, ...rest };
};
